export default __webpack_public_path__ + "static/media/logo.b34c16a8.jpeg";